export default __webpack_public_path__ + "static/media/asset-detail-iv-audio@2x.81cee73c.png";